import { render, staticRenderFns } from "./index.vue?vue&type=template&id=ef06d246&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef06d246",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dgq/mei_bao_pro/insuranceagent-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ef06d246')) {
      api.createRecord('ef06d246', component.options)
    } else {
      api.reload('ef06d246', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=ef06d246&scoped=true&", function () {
      api.rerender('ef06d246', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mp/wxaccount/index.vue"
export default component.exports